import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as ReviewService from '_services/review-service';
import * as AirportService from '_services/airport-service';

import { format } from 'date-fns';

const initialState = {
  reviews: null,
  averages: null,
  overallReviewScores: null,
  globalScores: null,
  scoreCard: [],
  selectedScore: null,
  twoAirportBookingsPortal: 0,
  averageDueTime: 0,
  dateType: "last48hrs",
  twoAirportBookingsApp: 0,
  twoAirportBookingsAll: 0,
  departureOnlyBookings: 0,
  arrivalOnlyBookings: 0,
  departureAndArrivalBookings: 0,
  graphBookingsAppDepartures: null,
  graphBookingsAppArrivals: null,
  graphBookingsPortalArrivals: null,
  graphBookingsPortalDepartures: null,
  globalStatus: 'idle',
  airportInformation: {},
  showAirport: false,
  selectedAirport: null,
  status: 'idle',
  statusObj: {},
  imageStatus: 'idle',
  preNotifiedAll: null,
  nonPreNotifiedAll: null,
  preNotifiedApp: null,
  nonPreNotifiedApp: null,
  preNotifiedSita: null,
  nonPreNotifiedSita: null,
  preNotifiedPortal: null,
  nonPreNotifiedPortal: null,
  airportImage: null,
  topAirportRankings: null,
  topAirportRankingsTotal: 0,
  error: null,
  waitingTimes: {},
  statusObj: {},
  reviewListSkip: { "Arrivals": 0, "Departures": 0, "All": 0 },
  globalScoresTotal: 0,

  //logo
  airportLogo: null,
  uploadAirportLogoStatus: "idle",
  uploadAirportLogoError: null,
  airportLogoStatus: 'idle',
  airportLogoError: null,
  logoBase64: null,
  logoBase64Status: "idle",
  logoBase64Error: null,

  reviewListReportData: [],
  reviewListStatus: "idle",
  reviewListError: null
};

// get averages 
export const getAverages = createAsyncThunk('reviews/getAverages', async (params) => {
  return ReviewService.getAverages(params);
});

//get rating averages
export const getReviewsAverages = createAsyncThunk('reviews/getReviewsAverages', async (params) => {
  return ReviewService.getReviewsAverages(params);
});


// get list 
export const getReviewsList = createAsyncThunk('reviews/getReviewsList', async (params) => {
  return ReviewService.getReviewsList(params);
});

// get review scores
export const getOverallReviewScores = createAsyncThunk('reviews/getOverallReviewScores', async (props) => {
  return ReviewService.getOverallReviewScores(props);
});

// get global scores 
export const getGlobalScores = createAsyncThunk('reviews/getGlobalScores', async (props = {}) => {
  return AirportService.getGlobalScores(props);
});

// get global scores 
export const getAirportInformation = createAsyncThunk('reviews/getAirportInformation', async (iata) => {
  return AirportService.getAirportInformation(iata);
});

// get flight counts to and from airport
export const getTwoAirportBookingsPortal = createAsyncThunk('reviews/getTwoAirportBookingsPortal', async (props) => {
  return AirportService.getTwoAirportBookingsPortal(props);
});

export const getTwoAirportBookingsApp = createAsyncThunk('reviews/getTwoAirportBookingsApp', async (props) => {
  return AirportService.getTwoAirportBookingsApp(props);
})

export const getTwoAirportBookingsSita = createAsyncThunk('reviews/getTwoAirportBookingsSita', async (props) => {
  return AirportService.getTwoAirportBookingsSita(props);
})

export const getTwoAirportBookingsAll = createAsyncThunk('reviews/getTwoAirportBookingsAll', async (props) => {
  return AirportService.getTwoAirportBookingsAll(props);
})

export const getNonPreNotifiedBookingsAll = createAsyncThunk('reviews/getNonPreNotifiedBookingsAll', async (props) => {
  return AirportService.getPreNotifiedBookings({ ...props, 'preNotified': false, 'filter': 'none' });
})

export const getPreNotifiedBookingsAll = createAsyncThunk('reviews/getPreNotifiedBookingsAll', async (props) => {
  return AirportService.getPreNotifiedBookings({ ...props, 'preNotified': true, 'filter': 'none' });
})

export const getPreNotifiedBookingsSita = createAsyncThunk('reviews/getPreNotifiedBookingsSita', async (props) => {
  return AirportService.getPreNotifiedBookings({ ...props, 'preNotified': true, 'filter': 'S' });
})

export const getNonPreNotifiedBookingsSita = createAsyncThunk('reviews/getNonPreNotifiedBookingsSita', async (props) => {
  return AirportService.getPreNotifiedBookings({ ...props, 'preNotified': false, 'filter': 'S' });
})

export const getPreNotifiedBookingsApp = createAsyncThunk('reviews/getNonPreNotifiedBookingsApp', async (props) => {
  return AirportService.getPreNotifiedBookings({ ...props, 'preNotified': false, 'filter': 'A' });
})

export const getNonPreNotifiedBookingsApp = createAsyncThunk('reviews/getNonPreNotifiedBookingsApp', async (props) => {
  return AirportService.getPreNotifiedBookings({ ...props, 'preNotified': false, 'filter': 'A' });
})

export const getPreNotifiedBookingsPortal = createAsyncThunk('reviews/getPreNotifiedBookingsPortal', async (props) => {
  return AirportService.getPreNotifiedBookings({ ...props, 'preNotified': true, 'filter': 'P' });
})

export const getNonPreNotifiedBookingsPortal = createAsyncThunk('reviews/getNonPreNotifiedBookingsPortal', async (props) => {
  return AirportService.getPreNotifiedBookings({ ...props, 'preNotified': false, 'filter': 'P' });
})


// get flight count departure only 
export const getDepartureOnlyBookings = createAsyncThunk('reviews/getDepartureOnlyBookings', async (props) => {
  return AirportService.getDepartureOnlyBookings(props);
});

// get flight count arrival only 
export const getArrivalsOnlyBookings = createAsyncThunk('reviews/getArrivalsOnlyBookings', async (props) => {
  return AirportService.getArrivalsOnlyBookings(props);
});

// get flight count departure only 
export const getDepartureandArrivalsBookings = createAsyncThunk('reviews/getDepartureandArrivalsBookings', async (props) => {
  return AirportService.departureAndArrivalBookings(props);
});

// get total monthly bookings app
export const getTwoAirportMonthlyBookingsAppDepartures = createAsyncThunk('reviews/getTwoAirportMonthlyBookingsAppDepartures', async (props) => {
  return AirportService.getTwoAirportMonthlyBookings(props);
});

export const getTwoAirportMonthlyBookingsAppArrivals = createAsyncThunk('reviews/getTwoAirportMonthlyBookingsAppArrivals', async (props) => {
  return AirportService.getTwoAirportMonthlyBookings(props);
});

export const getTwoAirportMonthlyBookingsPortalDepartures = createAsyncThunk('reviews/getTwoAirportMonthlyBookingsPortalDepartures', async (props) => {
  return AirportService.getTwoAirportMonthlyBookings(props);
});

export const getTwoAirportMonthlyBookingsPortalArrivals = createAsyncThunk('reviews/getTwoAirportMonthlyBookingsPortalArrivals', async (props) => {
  return AirportService.getTwoAirportMonthlyBookings(props);
});

export const getAverageDueTime = createAsyncThunk('reviews/getAverageDueTime', async (props) => {
  return AirportService.getAverageDueTime(props);
});

export const getTopAirportRanking = createAsyncThunk('reviews/getTopAirportRanking', async (props = {}) => {
  return AirportService.getTopAirportRanking(props);
});

export const getScoreCard = createAsyncThunk('reviews/getScoreCard', async (props) => {
  return AirportService.getScoreCard(props);
});

export const getAirportImage = createAsyncThunk('reviews/getAirportImage', async (props) => {
  return AirportService.getAirportImage(props);
})

export const getWaitingTimes = createAsyncThunk('reviews/getWaitingTimes', async (props) => {
  return AirportService.getWaitingTimes(props);
})

export const getWaitingTimesServiceFuncs = ["today", "last48hrs", "lastweek"].reduce(
  (a, type) => (
    {
      ...a, [type]: createAsyncThunk(`reviews/getWaitingTimes${type}`, async (props) => {
        return AirportService.getWaitingTimes({ ...props, type: type })
      }
      )
    }), {}
)


export const getAirportLogo = createAsyncThunk('adminTable/getAirportLogo', async (iata) => {

  return AirportService.getAirportLogo(iata);
});
export const uploadAirportLogo = createAsyncThunk('adminTable/uploadAirportLogo', async (data) => {
  return AirportService.UploadAirportLogoService(data);
});
export const getAirportBase64Logo = createAsyncThunk('adminTable/getAirportBase64Logo', async (iata) => {
  return AirportService.getAirportBase64Logo(iata);
});

// get list 
export const getReviewsListReportData = createAsyncThunk('reviews/getReviewsListReportData', async (params) => {
  return ReviewService.getReviewsList(params);
});

const reviewsSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {
    reset: (state) => initialState,
    setAirport: (state, action) => {
      return {
        ...state,
        selectedAirport: action.payload,
      }
    },
    showAirport: (state, action) => {
      return {
        ...state,
        showAirport: action.payload,
      }
    },
    setSelectedScore: (state, action) => {
      return {
        ...state,
        selectedScore: action.payload,
      }
    },
    clearSelectedScore: (state, action) => {
      return {
        ...state,
        selectedScore: null,
      }
    },
    setDateType: (state, action) => {
      return {
        ...state,
        dateType: action.payload
      }
    },
    modifyReviewListSkip: (state, action) => {
      let newSkip = state.reviewListSkip[action.payload.typeFilter] + action.payload.change
      newSkip = newSkip < 0 ? 0 : newSkip
      return {
        ...state,
        reviewListSkip: { ...state.reviewListSkip, [action.payload.typeFilter]: newSkip }
      }
    },
    resetReviewListSkip: (state, action) => {
      if (action.payload?.typeFilter) {
        return {
          ...state,
          reviewListSkip: { ...state.reviewListSkip, [action.payload.typeFilter]: 0 }
        }
      }
      return {
        ...state,
        reviewListSkip: initialState.reviewListSkip
      }
    },
    resetAirportLogoFlags: (state) => {
      state.uploadAirportLogoError = null
      state.uploadAirportLogoStatus = "idle"
    },
    resetReviewReportFlags: (state) => {
      state.reviewListStatus = "idle",
        state.reviewListError = null
    }
  },
  extraReducers: Object.assign({
    [getAirportImage.pending]: (state, action) => {
      return {
        ...state,
        statusObj: { ...state.statusObj, getAirportImage: 'loading' },
        status: 'loading',
      }
    },
    [getAirportImage.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getAirportImage: 'succeeded' },
        airportImage: action.payload,
      }
    },
    [getAirportImage.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getAirportImage: 'failed' },
        error: action.error.message,
      }
    },
    [getAverages.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getAverages: 'loading' },
      }
    },
    [getAverages.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getAverages: 'succeeded' },
        averages: action.payload,
      }
    },
    [getAverages.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getAverages: 'failed' },
        error: action.error.message,
        averages: null,
      }
    },
    [getReviewsAverages.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getAverages: 'loading' },
      }
    },
    [getReviewsAverages.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getAverages: 'succeeded' },
        averages: action.payload,
      }
    },
    [getReviewsAverages.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getAverages: 'failed' },
        error: action.error.message,
        averages: null,
      }
    },
    [getScoreCard.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getScoreCard: 'loading' },
      }
    },
    [getScoreCard.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getScoreCard: 'succeeded' },
        scoreCard: action.payload,
      }
    },
    [getScoreCard.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getScoreCard: 'failed' },
        error: action.error.message,
        scoreCard: [],
      }
    },
    [getReviewsList.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getReviewsList: 'loading' },
      }
    },
    [getReviewsList.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getReviewsList: 'succeeded' },
        reviews: action.payload,
      }
    },
    [getReviewsList.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getReviewsList: 'failed' },
        error: action.error.message,
      }
    },
    [getOverallReviewScores.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getOverallReviewScores: 'loading' },
      }
    },
    [getOverallReviewScores.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getOverallReviewScores: 'succeeded' },
        overallReviewScores: action.payload,
      }
    },
    [getOverallReviewScores.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getOverallReviewScores: 'failed' },
        error: action.error.message,
      }
    },
    [getGlobalScores.pending]: (state, action) => {
      return {
        ...state,
        globalStatus: 'loading',
        statusObj: { ...state.statusObj, getGlobalScores: 'loading' },
      }
    },
    [getGlobalScores.fulfilled]: (state, action) => {
      return {
        ...state,
        globalStatus: 'succeeded',
        statusObj: { ...state.statusObj, getGlobalScores: 'succeeded' },
        globalScores: action.payload.docs,
        globalScoresTotal: action.payload.totalRows,
      }
    },
    [getGlobalScores.rejected]: (state, action) => {
      return {
        ...state,
        globalStatus: 'failed',
        statusObj: { ...state.statusObj, getGlobalScores: 'failed' },
        error: action.error.message,
      }
    },
    [getAirportInformation.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getAirportInformation: 'loading' },
      }
    },
    [getAirportInformation.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getAirportInformation: 'succeeded' },
        airportInformation: {
          ...state.airportInformation,
          [action.payload.iata]: action.payload
        }
      }
    },
    [getAirportInformation.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getAirportInformation: 'failed' },
        error: action.error.message,
      }
    },
    [getTwoAirportBookingsAll.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getTwoAirportBookingsAll: 'loading' },
      }
    },
    [getTwoAirportBookingsAll.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getTwoAirportBookingsAll: 'succeeded' },
        twoAirportBookingsAll: action.payload,
      }
    },
    [getTwoAirportBookingsAll.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getTwoAirportBookingsAll: 'failed' },
        error: action.error.message,
      }
    },

    [getNonPreNotifiedBookingsAll.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getNonPreNotifiedBookingsAll: 'loading' },
      }
    },
    [getNonPreNotifiedBookingsAll.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getNonPreNotifiedBookingsAll: 'succeeded' },
        nonPreNotifiedAll: action.payload,
      }
    },
    [getNonPreNotifiedBookingsAll.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getNonPreNotifiedBookingsAll: 'failed' },
        error: action.error.message,
      }
    },


    [getPreNotifiedBookingsAll.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getPreNotifiedBookingsAll: 'loading' },
      }
    },
    [getPreNotifiedBookingsAll.fulfilled]: (state, action) => {

      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getPreNotifiedBookingsAll: 'succeeded' },
        preNotifiedAll: action.payload,
      }
    },
    [getPreNotifiedBookingsAll.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getPreNotifiedBookingsAll: 'failed' },
        error: action.error.message,
      }
    },

    [getPreNotifiedBookingsSita.pending]: (state, action) => {
      return {
        ...state,
        statusObj: { ...state.statusObj, getPreNotifiedBookingsSita: 'loading' },
        status: 'loading',
      }
    },
    [getPreNotifiedBookingsSita.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getPreNotifiedBookingsSita: 'succeeded' },
        preNotifiedSita: action.payload,
      }
    },
    [getPreNotifiedBookingsSita.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getPreNotifiedBookingsSita: 'failed' },
        error: action.error.message,
      }
    },
    [getNonPreNotifiedBookingsSita.pending]: (state, action) => {
      return {
        ...state,
        statusObj: { ...state.statusObj, getNonPreNotifiedBookingsSita: 'loading' },
        status: 'loading',
      }
    },
    [getNonPreNotifiedBookingsSita.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getNonPreNotifiedBookingsSita: 'succeeded' },
        nonPreNotifiedSita: action.payload,
      }
    },
    [getNonPreNotifiedBookingsSita.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getNonPreNotifiedBookingsSita: 'failed' },
        error: action.error.message,
      }
    },

    [getPreNotifiedBookingsApp.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getPreNotifiedBookingsApp: 'loading' },
      }
    },
    [getPreNotifiedBookingsApp.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getPreNotifiedBookingsApp: 'succeeded' },
        preNotifiedApp: action.payload,
      }
    },
    [getPreNotifiedBookingsApp.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getPreNotifiedBookingsApp: 'failed' },
        error: action.error.message,
      }
    },
    [getNonPreNotifiedBookingsApp.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getNonPreNotifiedBookingsApp: 'loading' },
      }
    },
    [getNonPreNotifiedBookingsApp.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getNonPreNotifiedBookingsApp: 'succeeded' },
        nonPreNotifiedApp: action.payload,
      }
    },
    [getNonPreNotifiedBookingsApp.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getNonPreNotifiedBookingsApp: 'failed' },
        error: action.error.message,
      }
    },

    [getPreNotifiedBookingsPortal.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getPreNotifiedBookingsPortal: 'loading' },
      }
    },
    [getPreNotifiedBookingsPortal.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getPreNotifiedBookingsPortal: 'succeeded' },
        preNotifiedPortal: action.payload,
      }
    },
    [getPreNotifiedBookingsPortal.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getPreNotifiedBookingsPortal: 'failed' },
        error: action.error.message,
      }
    },
    [getNonPreNotifiedBookingsPortal.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getNonPreNotifiedBookingsPortal: 'loading' },
      }
    },
    [getNonPreNotifiedBookingsPortal.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getNonPreNotifiedBookingsPortal: 'succeeded' },
        nonPreNotifiedPortal: action.payload,
      }
    },
    [getNonPreNotifiedBookingsPortal.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getNonPreNotifiedBookingsPortal: 'failed' },
        error: action.error.message,
      }
    },
    [getTwoAirportBookingsPortal.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getTwoAirportBookingsPortal: 'loading' },
      }
    },
    [getTwoAirportBookingsPortal.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getTwoAirportBookingsPortal: 'succeeded' },
        twoAirportBookingsPortal: action.payload,
      }
    },
    [getTwoAirportBookingsPortal.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getTwoAirportBookingsPortal: 'failed' },
        error: action.error.message,
      }
    },
    [getTwoAirportBookingsApp.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getTwoAirportBookingsApp: 'loading' },
      }
    },
    [getTwoAirportBookingsApp.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getTwoAirportBookingsApp: 'succeeded' },
        twoAirportBookingsApp: action.payload,
      }
    },
    [getTwoAirportBookingsApp.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getTwoAirportBookingsApp: 'failed' },
        error: action.error.message,
      }
    },
    [getTwoAirportBookingsSita.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
      }
    },
    [getTwoAirportBookingsSita.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        twoAirportBookingsSita: action.payload,
      }
    },
    [getTwoAirportBookingsSita.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        error: action.error.message,
      }
    },
    [getDepartureOnlyBookings.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getTwoAirportBookingsSita: 'loading' },
      }
    },
    [getDepartureOnlyBookings.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getDepartureOnlyBookings: 'succeeded' },
        departureOnlyBookings: action.payload,
      }
    },
    [getDepartureOnlyBookings.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getDepartureOnlyBookings: 'failed' },
        error: action.error.message,
      }
    },
    [getArrivalsOnlyBookings.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getArrivalsOnlyBookings: 'loading' },
      }
    },
    [getArrivalsOnlyBookings.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getArrivalsOnlyBookings: 'succeeded' },
        arrivalOnlyBookings: action.payload,
      }
    },
    [getArrivalsOnlyBookings.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getArrivalsOnlyBookings: 'failed' },
        error: action.error.message,
      }
    },
    [getDepartureandArrivalsBookings.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getDepartureandArrivalsBookings: 'loading' },
      }
    },
    [getDepartureandArrivalsBookings.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getDepartureandArrivalsBookings: 'succeeded' },
        departureAndArrivalBookings: action.payload,
      }
    },
    [getDepartureandArrivalsBookings.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getDepartureandArrivalsBookings: 'failed' },
        error: action.error.message,
      }
    },
    [getTwoAirportMonthlyBookingsAppDepartures.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getTwoAirportMonthlyBookingsAppDepartures: 'loading' },
      }
    },
    [getTwoAirportMonthlyBookingsAppDepartures.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getTwoAirportMonthlyBookingsAppDepartures: 'succeeded' },
        graphBookingsAppDepartures: action.payload,
      }
    },
    [getTwoAirportMonthlyBookingsAppDepartures.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getTwoAirportMonthlyBookingsAppDepartures: 'failed' },
        error: action.error.message,
      }
    },
    [getTwoAirportMonthlyBookingsAppArrivals.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getTwoAirportMonthlyBookingsAppArrivals: 'loading' },
      }
    },
    [getTwoAirportMonthlyBookingsAppArrivals.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getTwoAirportMonthlyBookingsAppArrivals: 'succeeded' },
        graphBookingsAppArrivals: action.payload,
      }
    },
    [getTwoAirportMonthlyBookingsAppArrivals.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getTwoAirportMonthlyBookingsAppArrivals: 'failed' },
        error: action.error.message,
      }
    },
    [getTwoAirportMonthlyBookingsPortalArrivals.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getTwoAirportMonthlyBookingsPortalArrivals: 'loading' },
      }
    },
    [getTwoAirportMonthlyBookingsPortalArrivals.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getTwoAirportMonthlyBookingsPortalArrivals: 'succeeded' },
        graphBookingsPortalArrivals: action.payload,
      }
    },
    [getTwoAirportMonthlyBookingsPortalArrivals.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getTwoAirportMonthlyBookingsPortalArrivals: 'failed' },
        error: action.error.message,
      }
    },
    [getTwoAirportMonthlyBookingsPortalDepartures.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getTwoAirportMonthlyBookingsPortalDepartures: 'loading' },
      }
    },
    [getTwoAirportMonthlyBookingsPortalDepartures.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getTwoAirportMonthlyBookingsPortalDepartures: 'succeeded' },
        graphBookingsPortalDepartures: action.payload,
      }
    },
    [getTwoAirportMonthlyBookingsPortalDepartures.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getTwoAirportMonthlyBookingsPortalDepartures: 'failed' },
        error: action.error.message,
      }
    },
    [getAverageDueTime.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getAverageDueTime: 'loading' },
      }
    },
    [getAverageDueTime.fulfilled]: (state, action) => {
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getAverageDueTime: 'succeeded' },
        averageDueTime: action.payload,
      }
    },
    [getAverageDueTime.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getAverageDueTime: 'failed' },
        error: action.error.message,
      }
    },
    [getTopAirportRanking.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getTopAirportRankings: "loading" }
      }
    },
    [getTopAirportRanking.fulfilled]: (state, action) => {
      const newObj = {};
      for (const key in action.payload.rankings) {
        const [_, newKey = key] = key.split('_');
        newObj[newKey] = action.payload.rankings[key];
      }
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getTopAirportRankings: "succeeded" },
        topAirportRankings: newObj,
        topAirportRankingsTotal: action.payload.totalRows,
      }
    },
    [getWaitingTimes.pending]: (state, action) => {
      return {
        ...state,
        status: 'loading',
        statusObj: { ...state.statusObj, getWaitingTimes: 'loading' },
      }
    },
    [getWaitingTimes.fulfilled]: (state, action) => {
      const byHourAverageWaitTime = action.payload.data.byHourAverageWaitTime;


      const graphData = Object.keys(byHourAverageWaitTime).map(key => ({ hour: key + ':00', "Waiting Time (minutes)": parseFloat((byHourAverageWaitTime[key] / (60)).toFixed(1)) }))
      return {
        ...state,
        status: 'succeeded',
        statusObj: { ...state.statusObj, getWaitingTimes: 'succeeded' },
        waitingTimes: {
          numProcessedPassengers: action.payload.data.numProcessedPassengers,
          graphData: graphData
        },
      }
    },
    [getWaitingTimes.rejected]: (state, action) => {
      return {
        ...state,
        status: 'failed',
        statusObj: { ...state.statusObj, getWaitingTimes: 'failed' },
        error: action.error.message,
      }
    },
    [uploadAirportLogo.pending]: (state, action) => {
      return {
        ...state,
        uploadAirportLogoStatus: 'loading',
      }
    },
    [uploadAirportLogo.fulfilled]: (state, action) => {
      return {
        ...state,
        uploadAirportLogoStatus: 'succeeded',
        airportLogo: action.payload,
      }
    },
    [uploadAirportLogo.rejected]: (state, action) => {
      return {
        ...state,
        uploadAirportLogoStatus: 'failed',
        uploadAirportLogoError: action.error.message
      }
    },
    [getAirportLogo.pending]: (state, action) => {
      return {
        ...state,
        airportLogoStatus: 'loading',
      }
    },
    [getAirportLogo.fulfilled]: (state, action) => {
      return {
        ...state,
        airportLogoStatus: 'succeeded',
        airportLogo: action.payload,
      }
    },
    [getAirportLogo.rejected]: (state, action) => {
      return {
        ...state,
        airportLogoStatus: 'failed',
        airportLogoError: action.error.message
      }
    },
    [getAirportBase64Logo.pending]: (state, action) => {
      return {
        ...state,
        logoBase64Status: 'loading',
      }
    },
    [getAirportBase64Logo.fulfilled]: (state, action) => {
      return {
        ...state,
        logoBase64Status: 'succeeded',
        logoBase64: action.payload,
      }
    },
    [getAirportBase64Logo.rejected]: (state, action) => {
      return {
        ...state,
        logoBase64Status: 'failed',
        logoBase64Error: action.error.message
      }
    },
    [getReviewsListReportData.pending]: (state, action) => {
      return {
        ...state,
        reviewListStatus: 'loading',

      }
    },
    [getReviewsListReportData.fulfilled]: (state, action) => {
      return {
        ...state,
        reviewListStatus: 'succeeded',
        reviewListReportData: action.payload,
      }
    },
    [getReviewsListReportData.rejected]: (state, action) => {
      return {
        ...state,
        reviewListStatus: 'failed',
        reviewListError: action.error.message,
      }
    }


  },

  )
});


export const selectGraphBookings = (state) => {
  if (state.reviews.graphBookingsAppDepartures == undefined) { return 0 }
  if (state.reviews.graphBookingsAppDepartures == null) { return 0 }
  if (state.reviews.graphBookingsAppArrivals == undefined) { return 0 }
  if (state.reviews.graphBookingsAppArrivals == null) { return 0 }

  let newList = [];

  for (let index = 0; index < state.reviews.graphBookingsAppDepartures.length; index++) {
    newList.push({
      "Departures": state.reviews.graphBookingsAppDepartures[index].bookingCount != undefined ? state.reviews.graphBookingsAppDepartures[index].bookingCount : 0,
      "Arrivals": state.reviews.graphBookingsAppArrivals[index] != undefined && state.reviews.graphBookingsAppArrivals[index].bookingCount != undefined ? state.reviews.graphBookingsAppArrivals[index].bookingCount : 0,
      "month": state.reviews.graphBookingsAppDepartures[index].month != undefined ? state.reviews.graphBookingsAppDepartures[index].month : 0,
      "type": state.reviews.graphBookingsAppDepartures[index].type != undefined ? state.reviews.graphBookingsAppDepartures[index].type : 0
    })
  }

  return newList;
}

export const selectHeatMapData = (state) => {
  if (!state.reviews.overallReviewScores) return [];

  let newList = [];

  state.reviews.overallReviewScores.forEach((score) => {

    let average = score['value']['sum']
    average = average / score['value']['count']
    average = Math.round(average * 10) / 10

    let newDate = score['key'][1];
    newDate = newDate.split('-');

    let object = {
      date: newDate[0] + '/' + newDate[1] + '/' + newDate[2],
      count: average
    }
    newList.push(object)

  })

  return newList;
}


// data for heat map
export const scoreCardData = (state) => {
  if (!state.reviews.scoreCard) return []

  const resultDict = {
    '0': {},                // mon
    '1': {},                // tue
    '2': {},                // wed
    '3': {},                // thu
    '4': {},                // fri
    '5': {},                // sat
    '6': {},                // sun
  };

  // arrange values into objects
  state.reviews.scoreCard.forEach((scoreCard, index) => {

    let dayOfWeek = scoreCard['key'][2];
    let hour = scoreCard['key'][3]
    let score = scoreCard['key'][4]
    let count = scoreCard['value'];

    if (hour == undefined || dayOfWeek == undefined || score == undefined || count == undefined) { }
    else {
      if (!resultDict || !resultDict[dayOfWeek] || !resultDict[dayOfWeek][hour] || resultDict[dayOfWeek] == {}) {
        // empty day of week
        resultDict[dayOfWeek][hour] = {
          5: { score: score == 5 ? count : 0, reviewList: score == 5 ? [scoreCard['doc']] : [] },
          4: { score: score == 4 ? count : 0, reviewList: score == 4 ? [scoreCard['doc']] : [] },
          3: { score: score == 3 ? count : 0, reviewList: score == 3 ? [scoreCard['doc']] : [] },
          2: { score: score == 2 ? count : 0, reviewList: score == 2 ? [scoreCard['doc']] : [] },
          1: { score: score == 1 ? count : 0, reviewList: score == 1 ? [scoreCard['doc']] : [] },
        }
      }
      else {
        // day of week already exsist
        resultDict[dayOfWeek][hour][score].reviewList.push(scoreCard['doc'])
        resultDict[dayOfWeek][hour][score].score += 1;
      }
    }
  })

  // calculate averages for each day
  let keys = Object.keys(resultDict);

  /* go through each day of week */
  keys.forEach((dayOfWeek, index) => {
    let hourKeys = Object.keys(resultDict[dayOfWeek])
    let average = 0;

    // for each hour
    hourKeys.forEach((hour, index) => {

      // for each score
      let scoreKeys = Object.keys(resultDict[dayOfWeek][hour])
      let sum = 0;
      let count = 0;
      scoreKeys.forEach((score, index) => {
        let multiplier = index + 1;
        sum = sum + (resultDict[dayOfWeek][hour][score]['score'] * multiplier)

        if (resultDict[dayOfWeek][hour][score]['score'] > 0) { count = count + resultDict[dayOfWeek][hour][score]['score'] }
      })
      resultDict[dayOfWeek][hour]['sum'] = sum / count
      resultDict[dayOfWeek][hour]['divier'] = count

    })
  })

  return resultDict;
}

export const selectDepartureOnlyBookings = (state) => {
  if (state.reviews.departureOnlyBookings == undefined) { return 0 }
  if (state.reviews.departureOnlyBookings == null) { return 0 }

  let key = Object.keys(state.reviews.departureOnlyBookings);
  if (key.length == 0) { return 0 }
  else { return state.reviews.departureOnlyBookings[key] };
}

export const selectArrivalsOnlyBookings = (state) => {
  if (state.reviews.arrivalOnlyBookings == undefined) { return 0 }
  if (state.reviews.arrivalOnlyBookings == null) { return 0 }

  let key = Object.keys(state.reviews.arrivalOnlyBookings);

  if (key.length == 0) { return 0 }
  else { return state.reviews.arrivalOnlyBookings[key] };
}

export const selectDepartureAndArrivalBookings = (state) => {
  if (state.reviews.departureAndArrivalBookings == undefined) { return 0 }
  if (state.reviews.departureAndArrivalBookings == null) { return 0 }

  let key = Object.keys(state.reviews.departureAndArrivalBookings);

  if (key.length == 0) { return 0 }
  else { return state.reviews.departureAndArrivalBookings[key] };
}

export const selectTwoAirportBookingsPortal = (state) => {
  if (state.reviews.twoAirportBookingsPortal == undefined) { return 0 }
  if (state.reviews.twoAirportBookingsPortal == null) { return 0 }

  let key = Object.keys(state.reviews.twoAirportBookingsPortal);

  if (key.length == 0) { return 0 }
  else { return state.reviews.twoAirportBookingsPortal[key] };
}

export const selectTwoAirportBookingsApp = (state) => {
  if (state.reviews.twoAirportBookingsApp == undefined) { return 0 }
  if (state.reviews.twoAirportBookingsApp == null) { return 0 }

  let key = Object.keys(state.reviews.twoAirportBookingsApp);

  if (key.length == 0) { return 0 }
  else { return state.reviews.twoAirportBookingsApp[key] };
}

export const selectTwoAirportBookingsSita = (state) => {
  if (state.reviews.twoAirportBookingsSita == undefined) { return 0 }
  if (state.reviews.twoAirportBookingsSita == null) { return 0 }

  let key = Object.keys(state.reviews.twoAirportBookingsSita);

  if (key.length == 0) { return 0 }
  else { return state.reviews.twoAirportBookingsSita[key] };
}

export const selectTwoAirportBookingsAll = (state) => {
  if (state.reviews.twoAirportBookingsAll == undefined) { return 0 }
  if (state.reviews.twoAirportBookingsAll == null) { return 0 }

  let key = Object.keys(state.reviews.twoAirportBookingsAll);

  if (key.length == 0) { return 0 }
  else { return state.reviews.twoAirportBookingsAll[key] };
}

export const selectTwoAirportBookings = (state) => {
  if (state.reviews.twoAirportBookingsPortal == undefined) { return 0 }
  if (state.reviews.twoAirportBookingsPortal == null) { return 0 }
  if (state.reviews.twoAirportBookingsApp == undefined) { return 0 }
  if (state.reviews.twoAirportBookingsApp == null) { return 0 }

  let key1 = Object.keys(state.reviews.twoAirportBookingsPortal);
  let key2 = Object.keys(state.reviews.twoAirportBookingsApp);

  if (key1.length == 0 && key2.length == 0) { return 0 }
  if (key1.length == 0 && key2.length == 0) { return 0 }
  if (key1.length != 0 && key2.length == 0) { return state.reviews.twoAirportBookingsPortal[key1] }
  if (key1.length == 0 && key2.length != 0) { return state.reviews.twoAirportBookingsApp[key2] }
  else { return state.reviews.twoAirportBookingsPortal[key1] + state.reviews.twoAirportBookingsApp[key2] }
}

function searchMatch(review, text) {
  if (!text) { return true }
  let flightNumber = review?.flight?.details?.carrierCode + review?.flight?.details?.flightNumber
  let name = review?.name
  let departureDate = format((new Date(review.flight.details.departureDate)), "yyyy-MM-dd")
  let flightDate = format((new Date(review.flight.details.departureDate)), "yyyy-MM-dd")
  return [flightNumber, name, departureDate, flightDate].some(val => val == "N/A" ? false : val == null ? false : val.toLowerCase().includes(text.toLowerCase()))
}

const createAirlineReviewListObject = (review, index) => {
  return {
    name: review.name ?? "N/A",
    userId: review.userId,
    date: format((new Date(review.date)), "yyyy-MM-dd"),
    flightDate: format((new Date(review.flight.details.departureDate)), "yyyy-MM-dd"),
    flightNumber: review.flight.details.carrierCode + review.flight.details.flightNumber,
    type: 'Airline',
    boarding: review.flight.review.boarding,
    onboard: review.flight.review.onboard,
    comments: review.flight.review.comments,
    count: index
  }
}

// selector used for data in list on review-list page
export const selectReviewsPageList = (dbUser, search, starFilter, typeFilter, skip) => (state) => {

  if (!state.reviews.reviews) return []


  let list = [];      // will hold end result
  let index = 1;      // used for count column

  // function used to create list object
  const createListObject = (props) => {
    if (props.review && props.review.userId) {
      return ({
        name: props.review.name ?? props.review.userId,
        date: format((new Date(props.review.flight.details.departureDate)), "yyyy-MM-dd"),
        flightDate: format((new Date(props.review.flight.details.departureDate)), "yyyy-MM-dd"),
        flightNumber: props.review.flight.details.carrierCode + props.review.flight.details.flightNumber,
        type: props.type,
        assistanceQuality: props.type == 'arrival' ? props.review.arrival.review.quality : props.review.departure.review.quality,
        staffAssistance: props.type == 'arrival' ? props.review.arrival.review.staff : props.review.departure.review.staff,
        comments: props.type == 'arrival' ? props.review.arrival.review.comments : props.review.departure.review.comments,
        waitingTime: props.type == 'arrival' ? props.review.arrival.review.waitingTime : props.review.departure.review.waitingTime,
        count: props.index,
        userId: props.review.userId
      })
    }
  }

  // create list of objects readable by table
  state.reviews.reviews.forEach((review => {

    // check if review contains search query

    if (review.bookingId != undefined && searchMatch(review, search)) {

      let object;

      // check if airline
      if (dbUser.details.type == 'AIRLINE') object = createAirlineReviewListObject(review, index)

      // check if departures
      else if (review.departure.details.iata == dbUser.details.authority && (typeFilter == 'All' || typeFilter == 'Departures')) { object = createListObject({ 'review': review, 'index': index, 'type': 'departure' }) }

      // trip is arrival
      else if (review.arrival.details.iata == dbUser.details.authority && (typeFilter == 'All' || typeFilter == 'Arrivals')) {
        object = createListObject({ 'review': review, 'index': index, 'type': 'arrival' })
      }

      // check if star filter
      if (starFilter == 'All' && object != undefined) {
        index++;    // increase count            
        list.push(object)
      }
      else {
        if (object != undefined && (object.assistanceQuality == starFilter || object.staffAssistance == starFilter)) {
          index++;    // increase count
          list.push(object)
        }
      }
    }
  }
  ))

  // let outputList = ((list.length - skip) < 50) ? list.slice(list.length-50, list.length) : list.slice(skip, skip+50)
  let outputList = list.slice(skip, skip + 50)

  // return count of full list for pagination purposes
  return { data: outputList, count: list.length };
}

const createListObject = ({ review, index, type }) => {
  return {
    name: review.name,
    userId: review.userId,
    date: format(new Date(review.date), "yyyy-MM-dd"),
    flightDate: format(new Date(review.flight.details.departureDate), "yyyy-MM-dd"),
    flightNumber: review.flight.details.carrierCode + review.flight.details.flightNumber,
    type: type === 'departure' ? 'Departure' : 'Arrival',
    assistanceQuality: type === 'departure' ? review.departure.review.quality : review.arrival.review.quality,
    staffQuality: type === 'departure' ? review.departure.review.staff : review.arrival.review.staff,
    comments: type === 'departure' ? review.departure.review.comments : review.arrival.review.comments,
    waitingTime: type === 'departure' ? review.departure.review.waitingTime : review.arrival.review.waitingTime,
    count: index
  };
};



export const selectReviewsListObject = (dbUser) => (state) => {
  if (!state.reviews.selectedScore) return []

  let index = 0;
  let list = [];


  let keys = Object.keys(state.reviews.selectedScore.data);

  keys.forEach((scoreKey => {

    index++;

    if (state.reviews.selectedScore.data[scoreKey].reviewList) {

      state.reviews.selectedScore.data[scoreKey].reviewList.forEach((review) => {
        let object;

        if (review && Object.keys(review).length) {
          if (dbUser.details.type === 'AIRLINE') {
            object = createAirlineReviewListObject(review, index);
          } else if (review.departure.details.iata === dbUser.details.authority) {
            object = createListObject({ review, index, type: 'departure' });
          } else if (review.arrival.details.iata === dbUser.details.authority) {
            object = createListObject({ review, index, type: 'arrival' });
          }

          if (object) list.push(object);
        }


      })
    }

  }))

  // return list object
  return list;
};



// sort by score
export const selectLowestReviews = (iata) => (state) => {
  if (state.reviews.reviews == undefined) { return [] }
  if (state.reviews.reviews == null) { return [] }

  let list = [];

  // loop through all scores
  for (let index = 0; index < 10; index++) {
    // loop through all items in the list
    for (let key = 0; key < state.reviews.reviews.length; key++) {
      // calculate score from departure of review
      if (state.reviews.reviews[key].departure.details == iata) {
        if (state.reviews.reviews[key].departure.review.quality + state.reviews.reviews[key].departure.review.staff == index) {
          list.push(createListObject(state.reviews.reviews[key]), iata)
        }
      }
      // calculate score from arrival of review
      else {
        if (state.reviews.reviews[key].arrival.review.quality + state.reviews.reviews[key].arrival.review.staff == index) {
          list.push(createListObject(state.reviews.reviews[key]), iata)
        }
      }
    }

  }

  // return list object
  return list;
};



export const selectReviewsAverage = (state) => {
  if (!state.reviews.averages) return 0
  // values exsist
  return state.reviews.averages.overall;
};

const getWaitingTimeStarAverage = (waitingTime) => {
  if (!waitingTime || typeof waitingTime !== "object") return 0;

  const waitingTimeWeights = {
    "less than 15mins": 5,
    "15 - 30 mins": 2.5,
    "more than 30 mins": 0,
  };

  let totalResponses = 0;
  let totalWeightedStars = 0;

  Object.entries(waitingTime).forEach(([label, count]) => {
    const numericCount = Number(count) || 0;
    const starValue = waitingTimeWeights[label];

    if (numericCount > 0 && starValue !== undefined) {
      totalResponses += numericCount;
      totalWeightedStars += numericCount * starValue;
    }
  });

  if (!totalResponses) return 0;

  return Number((totalWeightedStars / totalResponses).toFixed(2));
};

const getOverallStarAverage = (quality, staff, waitingTime) => {
  const numericScores = [quality, staff, waitingTime]
    .map((value) => Number(value))
    .filter((value) => !Number.isNaN(value));

  if (!numericScores.length) return "0.00";

  return (numericScores.reduce((sum, value) => sum + value, 0) / numericScores.length).toFixed(2);
};



// Bayesian average: pulls low-review airports toward the global mean.
// C = minimum review threshold. An airport needs ~C reviews before its rating is trusted at full weight.
const BAYESIAN_C = 20;

function bayesianScore(overallNum, totalReviews, globalMean) {
  return (BAYESIAN_C * globalMean + totalReviews * overallNum) / (BAYESIAN_C + totalReviews);
}

export const selectGlobalScores = (props) => (state) => {
  if (!state.reviews.globalScores) return []

  let list = [];

  function convertToDecimal(number) {
    const numberString = number.toString();

    if (!numberString.includes(".")) {
      return numberString + ".00";
    } else {
      return numberString;
    }
  }

  // loop through list and create table object
  state.reviews.globalScores.forEach((score, index) => {
    const waitingTimeAverage = getWaitingTimeStarAverage(score.waitingTime);
    const overallAverage = getOverallStarAverage(
      score.quality,
      score.staff,
      waitingTimeAverage
    );

    const totalReviews = Number(score.total) || 0;
    if (totalReviews > 0 && score.details.iata.includes(props)) {
      list.push({
        overall: convertToDecimal(overallAverage),
        overallNum: Number(overallAverage),
        staff: score.staff,
        quality: score.quality,
        waitingTime: waitingTimeAverage,
        airport: score.details.iata,
        totalReviews
      })
    }
  })

  // Sort by Bayesian weighted score so airports with few reviews don't dominate.
  // ACC (1 review, 5.0) ranks below BCM (76 reviews, 4.83) because its rating isn't yet statistically meaningful.
  const globalMean = list.length
    ? list.reduce((sum, s) => sum + s.overallNum, 0) / list.length
    : 3.5;

  list.sort((a, b) =>
    bayesianScore(b.overallNum, b.totalReviews, globalMean) -
    bayesianScore(a.overallNum, a.totalReviews, globalMean)
  );

  const indexList = []

  list.forEach((score, index) => {
    score.ranking = index + 1;
    indexList.push(score)       // add indexed item
  })

  return indexList;
};

export const selectTopAirports = (props) => (state) => {
  if (!state.reviews.globalScores || !state.reviews.topAirportRankings) return []

  let list = [];

  // loop through list and create table object
  state.reviews.globalScores.forEach((score, index) => {
    const waitingTimeAverage = getWaitingTimeStarAverage(score.waitingTime);
    const overallAverage = getOverallStarAverage(
      score.quality,
      score.staff,
      waitingTimeAverage
    );

    const totalReviews = Number(score.total) || 0;
    const volume = Number(state.reviews.topAirportRankings[score.details.iata]) || 0;
    if (totalReviews > 0 && volume > 0 && score.details.iata.includes(props)) {
      list.push({
        overall: overallAverage,
        staff: score.staff,
        quality: score.quality,
        waitingTime: waitingTimeAverage,
        airport: score.details.iata,
        totalReviews,
        volume
      })
    }
  })

  list.sort(function (a, b) {
    return b.volume - a.volume
  })

  const indexList = []

  list.forEach((score, index) => {
    score.ranking = index + 1;
    indexList.push(score)       // add indexed item
  })

  return indexList;
};


export const selectSelectedScore = state => state.reviews.selectedScore;
export const selectAirport = state => state.reviews.selectedAirport;
export const selectShowAirport = state => state.reviews.showAirport;
export const selectAirportInformation = state => state.reviews.airportInformation;
export const selectAirportStatus = state => state.reviews.status;
export const selectAirportImageStatus = state => state.reviews.statusObj?.["getAirportImage"];
export const selectAirportAnalyticsError = state => state.reviews.error;

export const { reset, setAirport, showAirport, setSelectedScore, clearSelectedScore, setDateType, modifyReviewListSkip, resetReviewListSkip, resetAirportLogoFlags, resetReviewReportFlags } = reviewsSlice.actions;
export const selectDateType = state => state.reviews.dateType;
export const selectAverages = state => state.reviews.averages;
export const selectReviewsStatus = state => state.reviews.status;
export const selectGlobalScoresStatus = state => state.reviews.globalStatus;

export const selectAirportImage = state => state.reviews.airportImage

export const selectPreNotifiedAll = state => {
  try {
    return Object.values(state.reviews.preNotifiedAll)[0] || 0;
  } catch (e) {
    return 0
  }
}

export const selectNonPreNotifiedAll = state => {
  try {
    return Object.values(state.reviews.nonPreNotifiedAll)[0] || 0;
  } catch (e) {
    return 0
  }
}

export const selectPreNotifiedSita = state => {
  try {
    return Object.values(state.reviews.preNotifiedSita)[0] || 0;
  } catch (e) {
    return 0
  }
}

export const selectNonPreNotifiedSita = state => {
  try {
    return Object.values(state.reviews.nonPreNotifiedSita)[0] || 0;
  } catch (e) {
    return 0
  }
}

export const selectPreNotifiedApp = state => {
  try {
    return Object.values(state.reviews.preNotifiedApp)[0] || 0;
  } catch (e) {
    return 0
  }
}

export const selectNonPreNotifiedApp = state => {
  try {
    return Object.values(state.reviews.nonPreNotifiedApp)[0] || 0;
  } catch (e) {
    return 0
  }
}

export const selectPreNotifiedPortal = state => {
  try {
    return Object.values(state.reviews.preNotifiedPortal)[0] || 0
  } catch (e) {
    return 0
  }
}

export const selectNonPreNotifiedPortal = state => {
  try {
    return Object.values(state.reviews.nonPreNotifiedPortal)[0] || 0
  } catch (e) {
    return 0
  }
};


export const selectWaitingTimes = state => {
  return state.reviews.waitingTimes
}
export const selectWaitingTimesStatus = state => state.reviews.getWaitingTimes
export const selectReviewListSkip = state => state.reviews.reviewListSkip;

export const selectAirportLogo = state => state.reviews.airportLogo;
export const selectUploadAirportLogoStatus = state => state.reviews.uploadAirportLogoStatus;
export const selectAirportLogoStatus = state => state.reviews.airportLogoStatus;

export const selectAirportBase64LogoStatus = state => state.reviews.logoBase64Status;
export const selectAirportBase64Logo = state => state.reviews.logoBase64;
export const selectReviewListReport = state => state.reviews.reviewListReportData;
export const selectReviewListReportStatus = state => state.reviews.reviewListStatus;

export default reviewsSlice.reducer;
